import React, { useState, useCallback, useMemo, useEffect } from 'react';
import { Box, CircularProgress, Alert, Typography, Grid, Paper } from '@mui/material';
import { SwipeUp, Money, Circle } from '@mui/icons-material';
import InputForm from './InputT';
import Data from '../Data/Data.json';
import { useAuthHeader } from '../Services/Auth/sessionAuth';
import axios from 'axios';
import { Crypter } from '../Functions/Security/Crypter';
import formatNumber from '../Functions/Traitement/FormatNumber';
import { BilletageOperation } from '../Models/BilletageOperation';

export interface BilletageItem {
  Code: string;
  Libelle: string;
  TypeValeur: string;
  DefaultValue: number;
  Valeur: number;
  ISActif: boolean;
}

interface BilletageProps {
  form?: any;
  disabled?: boolean;
  withTatal?: boolean;
  sansEntete?: boolean;
  onChange?: (data: { total: number; detail: BilletageOperation[] }) => void;
  double?: boolean;
  second?: boolean;
}

function Billetage(props: BilletageProps) {
  const [billetages, setBilletages] = useState<BilletageItem[]>([]);
  const [quantities, setQuantities] = useState<Record<string, number>>({});
  const [loading, setLoading] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const authHeader = useAuthHeader();

  const loadBilletage = async () => {
    setLoading(true);
    try {
      const config = {
        method: 'get',
        url: Data.ApiUrl.GetBilletage,
        headers: {
          'Authorization': authHeader(),
          'Content-Type': 'application/json',
          'CypherSearch': Crypter.encrypt("")
        }
      };
      const response = await axios.request(config);
      const res = JSON.parse(Crypter.decrypt(response.data)).Value;

      if (res.StatutCode === 200) {
        const data: BilletageItem[] = res.Result.Table || [];
        // filtrer les actifs
        const activeData = data.filter(item => item.ISActif);
        setBilletages(activeData);

        // Initialisation de toutes les quantités avec leur DefaultValue (ou 0)
        // const initialQtys = data.reduce((acc, item) => ({
        //   ...acc,
        //   [item.Code+(props.second? "_1": "")]: item.DefaultValue || 0
        // }), {});
        // setQuantities(initialQtys);

        var sum = 0;
        for (const item of data) {

          // props.form.setFieldValue(item.Code+(props.second? "_1": ""), formatNumber(item.DefaultValue || 0));
          const qty = item.DefaultValue || 0;
          sum += qty * item.DefaultValue;
        }
        props.form.setFieldValue(('TotalBilletage')+(props.second? "_1": ""), formatNumber(sum));

        if (!(props.form.getFieldValue(("Billetages")+(props.second? "_1": "")))){
          props.form.setFieldValue(("Billetages")+(props.second? "_1": ""), JSON.stringify("")) // Initialisation du champ Billetages dans le formulaire
        }
      }
    } catch {
      setError("Erreur de chargement.");
    } finally {
      setLoading(false);
    }
  };

  if (pageLoaded) {
    loadBilletage();
    setPageLoaded(false);
  }

  function getToatal() {

    var sum = 0;
    for (const item of billetages) {
      const qty = parseInt(props.form.getFieldValue(item.Code+(props.second? "_1": "")) || "0");
      sum += qty * item.Valeur;
    }



    props.form.setFieldValue(('TotalBilletage')+(props.second? "_1": ""), formatNumber(sum));
    if (props.onChange) {
      // 3. On prépare la liste complète (incluant les valeurs à 0) pour le parent
      const fullList: BilletageOperation[] = [];
      billetages.forEach(item => {
        fullList.push({
          codeBilletage: item.Code+(props.second? "_1": ""),
          quantite: props.form.getFieldValue(item.Code+(props.second? "_1": "")) || 0,
          valeurUnitaire: item.Valeur,
          sens: null,
          typeOperation: null
        });
      });
      // alert(JSON.stringify(fullList))
      props.form.setFieldValue(('Billetages')+(props.second? "_1": ""), fullList);
      // Retourne un objet propre contenant le total et le dictionnaire complet des billets
      props.onChange({
        total: props.form.getFieldValue(('TotalBilletage')+(props.second? "_1": "")) || 0, // On peut aussi recalculer le total ici si nécessaire
        detail: fullList
      });
    }
    // props.form.setFieldValue(('TotalBilletage')+(props.second? "_1": ""), 
    // formatNumber(billetages.reduce((sum, item) => {
    //   const qty = parseInt(props.form.getFieldValue(item.Code+(props.second? "_1": "")) || "0");
    //   return sum + (qty * item.Valeur);
    // }, 0))
    // billetages.map(item => parseInt((props.form.getFieldValue(item.Code+(props.second? "_1": "")) ? props.form.getFieldValue(item.Code+(props.second? "_1": "")) : 0)) * item.Valeur)
    // parseInt((props.form.getFieldValue("NOMB01")? props.form.getFieldValue("NOMB01") : 0))*10000+
    // parseInt((props.form.getFieldValue("NOMB02")? props.form.getFieldValue("NOMB02") : 0))*5000+
    // parseInt((props.form.getFieldValue("NOMB03")? props.form.getFieldValue("NOMB03") : 0))*2000+
    // parseInt((props.form.getFieldValue("NOMB04")? props.form.getFieldValue("NOMB04") : 0))*1000+
    // parseInt((props.form.getFieldValue("NOMB05")? props.form.getFieldValue("NOMB05") : 0))*500+
    // parseInt((props.form.getFieldValue("NOMB06")? props.form.getFieldValue("NOMB06") : 0))*500+
    // parseInt((props.form.getFieldValue("NOMB07")? props.form.getFieldValue("NOMB07") : 0))*100+
    // parseInt((props.form.getFieldValue("NOMB08")? props.form.getFieldValue("NOMB08") : 0))*50+
    // parseInt((props.form.getFieldValue("NOMB09")? props.form.getFieldValue("NOMB09") : 0))*25+
    // parseInt((props.form.getFieldValue("NOMB10")? props.form.getFieldValue("NOMB10") : 0))*10+
    // parseInt((props.form.getFieldValue("NOMB11")? props.form.getFieldValue("NOMB11") : 0))*5+
    // parseInt((props.form.getFieldValue("NOMB12")? props.form.getFieldValue("NOMB12") : 0))*2+
    // parseInt((props.form.getFieldValue("NOMB13")? props.form.getFieldValue("NOMB13") : 0))*1)
  }
  useEffect(() => {
    getToatal()
  })

  // Fonction utilitaire pour calculer le total à partir d'un état de quantités donné
  // const calculateTotal = useCallback((currentQuantities: Record<string, number>) => {
  //   return billetages.reduce((sum, item) => {
  //     const qty = currentQuantities[item.Code+(props.second? "_1": "")] || 0;
  //     return sum + (qty * item.Valeur);
  //   }, 0);
  // }, [billetages]);

  // // Calcul du total synchronisé pour l'affichage
  // const total = useMemo(() => calculateTotal(quantities), [quantities, calculateTotal]);

  // Gestion du changement
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const val = parseFloat(value) || 0;

    // 1. On calcule le nouvel état des quantités immédiatement
    const newQuantities = { ...quantities, [name]: val };
    setQuantities(newQuantities);

    // 2. On calcule le total basé sur ce nouvel état (et non sur l'ancien)
    // const newTotal = calculateTotal(newQuantities);

    // 3. On prépare la liste complète (incluant les valeurs à 0) pour le parent
    const fullList: BilletageOperation[] = [];
    billetages.forEach(item => {
      fullList.push({
        codeBilletage: item.Code+(props.second? "_1": ""),
        quantite: props.form.getFieldValue(item.Code+(props.second? "_1": "")) || 0,
        valeurUnitaire: item.Valeur,
        sens: null,
        typeOperation: null
      });
    });
    // alert(JSON.stringify(fullList))
    props.form.setFieldValue(('Billetages')+(props.second? "_1": ""), fullList); // On peut aussi stocker le détail dans le formulaire si besoin
    if (props.onChange) {
      // Retourne un objet propre contenant le total et le dictionnaire complet des billets
      props.onChange({
        total: props.form.getFieldValue(('TotalBilletage')+(props.second? "_1": "")) || 0, // On peut aussi recalculer le total ici si nécessaire
        detail: fullList
      });
    }
  };

  const items = useMemo(() => {
    const active = billetages.filter(i => i.ISActif);
    return {
      billets: active.filter(i => i.TypeValeur === 'BILLET'),
      pieces: active.filter(i => i.TypeValeur === 'PIECE')
    };
  }, [billetages]);

  const renderInput = (item: BilletageItem) => {
    const currentQty = quantities[item.Code+(props.second? "_1": "")] ?? item.DefaultValue ?? 0;
    const currentSubTotal = currentQty * item.Valeur;

    return (
      <Box key={item.Code+(props.second? "_1": "")} sx={{ mb: 1.5, display: 'flex', alignItems: 'center' }}>
        <InputForm
          onChange={handleChange}
          disabled={props.disabled}
          width={12}
          label={item.Libelle}
          icon={<SwipeUp fontSize='small' />}
          name={item.Code+(props.second? "_1": "")}
          type='number'
          value={currentQty} // Utilisation de value pour un composant contrôlé
        />
        {props.double && (
          <InputForm
            disabled
            taille={60}
            money
            width={8}
            label=''
            name={`D_${item.Code+(props.second? "_1": "")}`}
            type='text'
            value={currentSubTotal} // Changement de defaultValue à value pour la réactivité
          />
        )}
      </Box>
    );
  };

  return (
    <Paper className='bordure1' sx={{ p: 3, borderRadius: 2 }}>
      {loading ? <CircularProgress /> : error ? <Alert severity="error">{error}</Alert> : (
        <Grid container spacing={4}>
          {/* Section Billets */}
          <Grid item xs={12} md={4}>
            <Box sx={{ p: 2, borderRadius: 2, bgcolor: '#e9f2fa', borderLeft: '6px solid #116599' }}>
              <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', color: '#116599' }}>
                <Money sx={{ mr: 1 }} /> Billets
              </Typography>
              {items.billets.map(renderInput)}
            </Box>
          </Grid>

          {/* Section Pièces */}
          <Grid item xs={12} md={8}>
            <Box sx={{ p: 2, borderRadius: 2, bgcolor: '#fff3e0', borderLeft: '6px solid #ed6c02' }}>
              <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', color: '#ed6c02' }}>
                <Circle sx={{ mr: 1, fontSize: 18 }} /> Pièces
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>{items.pieces.slice(0, 5).map(renderInput)}</Grid>
                <Grid item xs={12} sm={6}>{items.pieces.slice(5).map(renderInput)}</Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      )}

      {props.withTatal && (
        <Box mt={3} pt={2} borderTop="2px solid #ddd">
          <InputForm
            notRequired
            width={12}
            disabled
            label='Total Billetage'
            name={('TotalBilletage')+(props.second? "_1": "")}
            type='text'
          // value={total.toLocaleString()} // Utilisation de value
          />
        </Box>
      )}
    </Paper>
  );
}

export default Billetage;